export const INIT_SCHEMA_ID_KEY = 'graphcdn:init-schema-id'
export const ONBOARDING_APP_NAME = 'graphcdn:onboarding-app-name'

export const GET_STARTED_BEGAN = 'graphcdn:get-started-began'
export const REDIRECT = 'graphcdn:redirect'
export const REDIRECT_AFTER_LOGIN = 'graphcdn:redirect-after-login'
export const HAS_ACCOUNT_KEY = 'graphcdn:has-account'
